import React from 'react';
import { ID, withCodes2 } from 'app/blocks/common/codes';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import { compose } from 'app/blocks/common/utils';
import withScrollToTop from 'app/blocks/common/withScrollToTop';
import Context from 'app/pages/license-signing-process/context/Context';
import OnlineOpenPaymentContext from 'app/pages/license-signing-process/Payment/OnlineOpenPaymentContext';
import StepEnum from 'app/pages/license-signing-process/StepEnum';
import PaymentPanel from './PaymentPanel';
import { Button, LinkButton } from '../../../../blocks/buttons/buttons';
import { BackButton, ForwardButton } from '../../buttons';

class ReviewFinalChargesStep extends React.PureComponent {
    render() {
        const {
            deleteDraft,
            goBack,
            isChinaOaWithForeignBilling,
            isConfirming,
            isDraftBeingDeleted,
            isDraftDeletionAllowed,
            isOrderExisting,
            isSaveAndPreviewAllowed,
            isSavingForLater,
            l,
            onReviewConfirm,
            order,
            saveForLater,
        } = this.props;

        return (
            <>
                <section className="payment payment--review">
                    <PaymentPanel order={order} />
                </section>
                <div className="licenseSigningProcessPage-backAndForth licenseSigningProcessPage-backAndForth--payment">
                    <div className="page-controls">
                        <BackButton onClick={goBack}>
                            {l('LICENSE_SIGNING.BUTTON.BACK_TO_DISCOUNT_AND_BILLING')}
                        </BackButton>

                        {isDraftDeletionAllowed && (
                            <LinkButton
                                data-seleniumid="deleteDraftButton"
                                isDanger
                                isProcessing={isDraftBeingDeleted}
                                isUnderline
                                onClick={deleteDraft}
                            >
                                <SvgIcon.delete iconTitle="Delete Icon" />
                                {l('LICENSE_SIGNING.BUTTON.DELETE_DRAFT')}
                            </LinkButton>
                        )}
                        {!isOrderExisting && (
                            <Button
                                data-seleniumid="saveForLaterButton"
                                isProcessing={isSavingForLater}
                                onClick={saveForLater}
                                processingLabel={l('BUTTONS.SAVING')}
                            >
                                {l('LICENSE_SIGNING.BUTTON.SAVE_FOR_LATER')}
                            </Button>
                        )}
                        <ForwardButton
                            data-seleniumid="goForthButton"
                            disabled={
                                order.pricingDetails.pricesUnavailable ||
                                !isSaveAndPreviewAllowed ||
                                isChinaOaWithForeignBilling
                            }
                            isProcessing={isConfirming}
                            onClick={onReviewConfirm}
                            processingLabel={l('BUTTONS.PROCESSING')}
                        >
                            {l('LICENSE_SIGNING.BUTTON.CONFIRM_AND_PROCEED')}
                        </ForwardButton>
                    </div>
                </div>
            </>
        );
    }
}

export { ReviewFinalChargesStep };
export default compose(
    withScrollToTop,
    Context.withContext(state => ({
        hasLicenseSubmissionStep: !!state.steps.find(x => x.id === StepEnum.LICENSE_SUBMISSION),
        goBack: state.goBack,
    })),
    OnlineOpenPaymentContext.withContext(state => ({
        isChinaOaWithForeignBilling: state.isChinaOaWithForeignBilling,
        isConfirming: state.initiate.isConfirming,
        onReviewConfirm: state.onReviewFinalChargesConfirm,
        canConfirm: !!state.initiate?.payment?.paymentDetails?.paymentMethod,
        order: state.order,
        isSaveAndPreviewAllowed: state.initiate.isSaveAndPreviewAllowed,
        isSavingForLater: state.initiate.isSavingForLater,
        saveForLater: state.saveForLater,
        isDraftBeingDeleted: state.initiate.isDraftBeingDeleted,
        deleteDraft: state.deleteDraft,
        isDraftDeletionAllowed: state.canDeleteDraft,
        isOrderExisting: state.isOrderExisting,
    })),
    withCodes2(ID.BUTTONS, ID.LICENSE_SIGNING),
)(ReviewFinalChargesStep);
